import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorMarginTrading = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M9.75 7a4.25 4.25 0 1 1 8.5 0 4.25 4.25 0 0 1-8.5 0ZM14 1.25a5.75 5.75 0 1 0 0 11.5 5.75 5.75 0 0 0 0-11.5Zm6.412 14.209a.693.693 0 0 0-.905-.143l-4.547 2.888-.766.658a2.75 2.75 0 0 1-2.716.504l-1.67-.596.504-1.413 1.67.596c.423.151.894.064 1.234-.229l.135-.116-1.109-.926a6.19 6.19 0 0 0-3.373-1.41 7.395 7.395 0 0 0-2.354.152l-.765.174V20c1.611-.09 3.227.067 4.791.468l2.063.528A1.72 1.72 0 0 0 14 20.751l6.27-4.278c.336-.23.403-.7.142-1.014Zm-5.84 1.214 4.13-2.624a2.193 2.193 0 0 1 2.413 3.663l-6.27 4.278a3.22 3.22 0 0 1-2.613.46l-2.063-.53a14.25 14.25 0 0 0-4.473-.414l-.114.007a1.25 1.25 0 0 1-1.332-1.247v-5.04c0-.482.334-.9.804-1.007l1.127-.258a8.896 8.896 0 0 1 2.832-.181 7.69 7.69 0 0 1 4.19 1.75l1.37 1.143ZM1.75 14a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-1.5 0v-6.5a.75.75 0 0 1 .75-.75Z"
    />
    <path fill="#F7A600" d="M16 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
  </svg>
);
export default SvgTwoColorMarginTrading;
